"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StreamType;
(function (StreamType) {
    StreamType["PRIMARY"] = "primary";
    StreamType["SECONDARY"] = "secondary";
})(StreamType = exports.StreamType || (exports.StreamType = {}));
var ProxyRequestType;
(function (ProxyRequestType) {
    ProxyRequestType[ProxyRequestType["MASTER_PLAYLIST"] = 0] = "MASTER_PLAYLIST";
    ProxyRequestType[ProxyRequestType["MEDIA_PLAYLIST"] = 1] = "MEDIA_PLAYLIST";
    ProxyRequestType[ProxyRequestType["SEGMENT"] = 2] = "SEGMENT";
    ProxyRequestType[ProxyRequestType["UNKNOWN"] = 3] = "UNKNOWN";
})(ProxyRequestType = exports.ProxyRequestType || (exports.ProxyRequestType = {}));
